import React from "react";

interface Props {
  className: string;
  onClick?: () => void;
}

const SearchIcon: React.FC<Props> = (props) => (
  <svg
    onClick={props.onClick}
    className={props.className}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

export default SearchIcon;
